import Vue from 'vue'
import Router from 'vue-router'
import Translations from './translations'
import Tournaments from './tournaments'
// import Clients from './clients'
import Pauses from './pauses'
// import Providers from './providers'
import Monitoring from './monitoring'
import RecognitionControls from './recognitionControls'
import Sources from './sources'
// import Users from './users'
import Bookings from './bookings'
import Entities from './entities'
import Reports from './reports'
import Settings from './settings'
import Translation from './translation.js'
import Auth from './auth.js'
import TraderMode from './traderMode.js'
// import Logos from './logos.js'
import store from 'store2'
import { hasAbility } from '@/utils/user'
import MessengerMode from '@/router/messengerMode'
import Coordination from '@/router/coordination'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    ...Translations,
    ...RecognitionControls,
    ...Tournaments,
    // ...Clients,
    ...Pauses,
    // ...Providers,
    ...Monitoring,
    ...Sources,
    // ...Users,
    ...Bookings,
    ...Entities,
    // ...Logos,
    ...Reports,
    ...Settings,
    ...Translation,
    ...Auth,
    ...TraderMode,
    ...MessengerMode,
    ...Coordination
  ]
})

router.beforeEach((to, from, next) => {
  const storedUser = store('sportlevel-user')

  const hasAbilityInStoredUser = hasAbility.bind(storedUser)

  if (
    to.meta.requiredAbilities &&
    to.meta.requiredAbilities.length &&
    storedUser &&
    storedUser.abilities &&
    storedUser.abilities.length
  ) {
    let requiredAbilities = to.meta.requiredAbilities

    if (to.name === 'coordination' && to.params.streamGroupName) {
      requiredAbilities = requiredAbilities.filter(ability => ability === to.params.streamGroupName)
    }

    if (hasAbilityInStoredUser(requiredAbilities)) {
      next()
    } else {
      next({ name: 'translations' })
    }
  } else {
    next()
  }
})

export default router
